import type { LocalePack } from './types.js';

/** Portuguese (Português) */
export const pt: LocalePack = {
  headerTitle: 'Editor de fotos',
  headerSubtitle: 'Edite a sua imagem com facilidade',
  applyButton: 'Aplicar',
  cancelButton: 'Fechar',
  undo: 'Desfazer',
  redo: 'Refazer',
  fullscreen: 'Tela cheia',
  fit: 'Ajustar',
  zoomTooltip: 'Zoom · +/− · 0 ajustar · 1 100 %',

  emptyStateTitle: 'Solte uma imagem ou clique para enviar',
  emptyStateSubtitle: 'Suportado: PNG, JPEG, HEIC',

  calloutLabelText: 'Etiqueta',

  tool: {
    select: 'Selecionar',
    crop: 'Recortar',
    draw: 'Desenhar',
    eraser: 'Borracha',
    text: 'Texto',
    shapes: 'Formas',
    callout: 'Nota',
    filters: 'Filtros',
    adjust: 'Ajustar',
    move: 'Mover',
    pen: 'Caneta',
    zoom: 'Zoom',
    zoomIn: 'Aproximar',
    zoomOut: 'Afastar',
    rotateLeft: 'Girar à esquerda',
    rotateRight: 'Girar à direita',
    flipH: 'Espelhar H',
    flipV: 'Espelhar V',
    reset: 'Redefinir',
  },

  shape: {
    circle: 'Círculo',
    ellipse: 'Elipse',
    square: 'Quadrado',
    rectangle: 'Retângulo',
    arrow: 'Seta',
    polyline: 'Linha',
  },

  filter: {
    none: 'Original',
    grayscale: 'P & B',
    sepia: 'Sépia',
    vintage: 'Vintage',
    cool: 'Frio',
    warm: 'Quente',
    invert: 'Inverter',
  },

  props: {
    title: {
      draw: 'Desenhar',
      eraser: 'Borracha',
      text: 'Texto',
      crop: 'Recortar',
      shapes: 'Formas',
      callout: 'Nota',
      filters: 'Filtros',
      adjust: 'Ajustar',
      move: 'Mover',
    },
    aspectRatio: 'Proporção',
    applyCrop: 'Aplicar recorte',
    cancel: 'Cancelar',
    shape: 'Forma',
    preset: 'Predefinição',
    resetEffects: 'Redefinir efeitos',
    resetAdjustments: 'Redefinir ajustes',
    deleteSelected: 'Excluir seleção',
    colors: 'Cores',
    recent: 'Recentes',
    customColor: 'Cor personalizada',
    brushSize: 'Tamanho do pincel',
    strokeWidth: 'Espessura do traço',
    opacity: 'Opacidade',
    eraserSize: 'Tamanho da borracha',
    fontSize: 'Tamanho da fonte',
    brightness: 'Brilho',
    contrast: 'Contraste',
    saturation: 'Saturação',
    blur: 'Desfoque',
    quickActions: 'Ações rápidas',
    hintMove:
      'Arraste para mover · aperte ou role para dar zoom · escolha uma ferramenta para começar.',
    hintEraser: 'Toque ou arraste sobre uma anotação para removê-la.',
  },
};
